import { render, staticRenderFns } from "./wDateText.vue?vue&type=template&id=50be4eda&scoped=true&"
import script from "./wDateText.vue?vue&type=script&lang=js&"
export * from "./wDateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be4eda",
  null
  
)

export default component.exports